import { render, staticRenderFns } from "./TextAreaCustom.vue?vue&type=template&id=26c845eb&scoped=true&"
import script from "./TextAreaCustom.vue?vue&type=script&lang=js&"
export * from "./TextAreaCustom.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaCustom.vue?vue&type=style&index=0&id=26c845eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c845eb",
  null
  
)

export default component.exports